import React from "react";
import styles from "./Input.module.css";

export interface InputProps {
  type?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  icon?: React.ReactNode;
  error?: string;
  name?: string;
  autoComplete?: string;
  disabled?: boolean;
  className?: string;
  rightIcon?: React.ReactNode;
}

const Input: React.FC<InputProps> = ({
  type = "text",
  value,
  onChange,
  placeholder,
  icon,
  error,
  name,
  autoComplete,
  disabled = false,
  className = "",
  rightIcon,
}) => {
  return (
    <div className={styles.inputGroup}>
      <div
        className={
          styles.inputWrapper + (error ? " " + styles.errorBorder : "")
        }
        style={{ position: "relative" }}
      >
        {icon && <span className={styles.inputIcon}>{icon}</span>}
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          name={name}
          autoComplete={autoComplete}
          className={`${styles.input} ${className}`.trim()}
          disabled={disabled}
        />
        {rightIcon && (
          <span className={styles.inputRightIcon}>{rightIcon}</span>
        )}
      </div>
      {error && <div className={styles.error}>{error}</div>}
    </div>
  );
};

export default Input;
